module.exports = __webpack_public_path__ + "static/media/transparent-pen.b7768a47.png";